export enum ScreenSize {
  xsmall,
  small,
  medium,
  large,
  xlarge
}
